var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_3378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4292 12.0717L20.8584 22.5009L10.4292 32.9301L-1.52588e-05 22.5009L10.4292 12.0717ZM10.4292 24.4694C11.5161 24.4694 12.3994 23.5878 12.3994 22.4991C12.3994 21.4105 11.5178 20.5289 10.4292 20.5289C9.34055 20.5289 8.45894 21.4105 8.45894 22.4991C8.45894 23.5878 9.34055 24.4694 10.4292 24.4694Z",
    fill: "#C90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0718 10.4292L22.501 0L32.9302 10.4292L22.501 20.8584L12.0718 10.4292ZM24.4695 10.4292C24.4695 9.34229 23.5879 8.45896 22.4992 8.45896C21.4106 8.45896 20.529 9.34057 20.529 10.4292C20.529 11.5178 21.4106 12.3995 22.4992 12.3995C23.5879 12.3995 24.4695 11.5178 24.4695 10.4292Z",
    fill: "#C90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5708 12.0717L45 22.4992L34.5708 32.9284L24.1416 22.4992L34.5708 12.0699V12.0717ZM34.5708 24.4694C35.6577 24.4694 36.541 23.5878 36.541 22.4992C36.541 21.4105 35.6594 20.5289 34.5708 20.5289C33.4822 20.5289 32.6023 21.4105 32.6023 22.4992C32.6023 23.5878 33.4839 24.4694 34.5708 24.4694Z",
    fill: "#C90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9282 34.5708L22.499 45L12.0698 34.5708L22.499 24.1416L32.9282 34.5708ZM20.5305 34.5708C20.5305 35.6577 21.4121 36.5411 22.5007 36.5411C23.5894 36.5411 24.471 35.6595 24.471 34.5708C24.471 33.4822 23.5894 32.6006 22.5007 32.6006C21.4121 32.6006 20.5305 33.4822 20.5305 34.5708Z",
    fill: "#C90000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_3378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 45 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingIcon);
export default __webpack_public_path__ + "static/media/heading-icon.81083801aff030b8061bde9a86ad8027.svg";
export { ForwardRef as ReactComponent };